import { SERVER_URL } from "constants/index";
import { stringify } from "qs";

export const placeOrder = (cartId, callback) => {
  let queryShippingInfo = {
    addressInformation: {
      shipping_address: {
        countryId: "HR",
        regionId: "525",
        regionCode: "HR-14",
        region: "Osječko-baranjska županija",
        street: ["address 123"],
        company: "xxx",
        telephone: "12345678",
        postcode: "31000",
        city: "osijek",
        firstname: "Adrian",
        lastname: "Bece"
      },
      shipping_method_code: "flatrate",
      shipping_carrier_code: "flatrate"
    }
  };

  let queryPlaceOrder = {
    cartId: `"${cartId}"`,
    email: "adrianBece@test.com",
    billingAddress: {
      countryId: "HR",
      regionId: "525",
      regionCode: "HR-14",
      region: "Osječko-baranjska županija",
      street: ["address 123"],
      company: "xxx",
      telephone: "12345678",
      postcode: "31000",
      city: "osijek",
      firstname: "Adrian",
      lastname: "Bece"
    },
    paymentMethod: {
      method: "checkmo"
    }
  };

  queryShippingInfo = stringify(queryShippingInfo);
  queryPlaceOrder = stringify(queryPlaceOrder);

  fetch(
    SERVER_URL +
      "guest-carts/" +
      cartId +
      "/shipping-information?" +
      queryShippingInfo,
    {
      method: "POST"
    }
  ).then(() => {
    fetch(
      SERVER_URL +
        "guest-carts/" +
        cartId +
        "/payment-information?" +
        queryPlaceOrder,
      {
        method: "POST"
      }
    ).then(response => callback());
  });
};

export default placeOrder;



// WEBPACK FOOTER //
// ./src/components/InstantCheckout/actions/placeOrder.js